var _a;
import { ProductTourMutationTypes } from '@/types/product-tour';
export var state = function () { return ({
    isRunning: false,
    activeTourId: null,
    currentStepIndex: 0
}); };
export var getters = {
    isRunning: function (state) { return state.isRunning; },
    activeTourId: function (state) { return state.activeTourId; },
    currentStepIndex: function (state) { return state.currentStepIndex; }
};
export var mutations = (_a = {},
    _a[ProductTourMutationTypes.INIT_STATE] = function (state, payload) {
        Object.assign(state, payload);
    },
    _a[ProductTourMutationTypes.SET_RUNNING] = function (state, payload) {
        state.isRunning = payload;
    },
    _a[ProductTourMutationTypes.SET_ACTIVE_TOUR_ID] = function (state, payload) {
        state.activeTourId = payload;
    },
    _a[ProductTourMutationTypes.SET_CURRENT_STEP_INDEX] = function (state, payload) {
        state.currentStepIndex = payload;
    },
    _a);
export var actions = {
    initState: function (_a) {
        var commit = _a.commit;
        commit(ProductTourMutationTypes.INIT_STATE, state());
    },
    setRunning: function (_a, payload) {
        var commit = _a.commit;
        commit(ProductTourMutationTypes.SET_RUNNING, payload);
    },
    setActiveTourId: function (_a, payload) {
        var commit = _a.commit;
        commit(ProductTourMutationTypes.SET_ACTIVE_TOUR_ID, payload);
    },
    setCurrentStepIndex: function (_a, payload) {
        var commit = _a.commit;
        commit(ProductTourMutationTypes.SET_CURRENT_STEP_INDEX, payload);
    }
};
